module.exports = __webpack_public_path__ + "static/media/pager.ba7a04df.svg";